import type { ReactNode } from "react"
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar"
import { AppSidebar } from "./AppSidebar"
import { GlobalDropZone } from "../upload/GlobalDropZone"
import { StatusBar } from "./StatusBar"

interface AppLayoutProps {
  children: ReactNode
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <SidebarProvider defaultOpen={true}>
      <GlobalDropZone>
        <div className="flex h-screen w-full overflow-hidden">
          <AppSidebar />

          <SidebarInset className="flex flex-col flex-1 overflow-hidden">
            {children}
            <StatusBar />
          </SidebarInset>
        </div>
      </GlobalDropZone>
    </SidebarProvider>
  )
}
